export { Blink } from "./Blink"
export type { BlinkProps } from "./Blink"
